import { ReduxStore } from 'store/types';

function getAllErrorMessage(state: ReduxStore): string {
  return state.product.getAll.config.errorMessage;
}

export default getAllErrorMessage;
